import React from 'react'
import { Pagination } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const PaginatePos = ({ pagespos, pagepos }) => {
  return (
    pagespos > 1 && (
      <Pagination size='sm' className='my-2 themed-pagination'>
        {[...Array(pagespos).keys()].map((x) => (
          <LinkContainer key={x + 1} to={`/pagepos/${x + 1}`}>
            <Pagination.Item active={x + 1 === pagepos}>
              {x + 1}
            </Pagination.Item>
          </LinkContainer>
        ))}
      </Pagination>
    )
  )
}

export default PaginatePos
